// extracted by mini-css-extract-plugin
export default {"dateDisplay":"DateDisplay_dateDisplay__Xu05n","text":"DateDisplay_text__lFq6i"};